/* eslint-disable @typescript-eslint/no-explicit-any */
import { first, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import { CheckoutState, checkoutQuery, fromCheckoutActions } from '../+state';

@Injectable()
export class CreditBundlesResolver {
  constructor(private _store: Store<CheckoutState>) {}

  /*
   * Resolve CreditBundles
   * 1. Selects CreditBundles from the store
   * 2. Checks CreditBundles.id is present
   *    -If it doesn't exist:
   *    1. GetCreditBundles with :id
   * 3. Checks paramQuoteUuid from url with present id
   *    - If it doesn't match:
   *    1. GetCreditBundles with :id
   *    - If it does match:
   *    1. Return getCreditBundles from Store
   */
  public resolve(): Observable<any> {
    return this._store.select(checkoutQuery.getCreditBundles).pipe(
      switchMap(() => {
        // TODO
        // for now we cannot use cached data
        // there is no delta sync/realtime infrastructure
        this.getCreditBundles();

        return of(true);

        // if (!creditBundles) {
        //   this.getCreditBundles();
        // }

        // return of(creditBundles);
      }),
      first()
    );
  }

  /*
   * trigger fetching quote to send
   * 1. Dispatch CreditBundles action
   * 2. Listening to setCreditBundles
   * 3. Return payload of setCreditBundles
   */

  private getCreditBundles() {
    this._store.dispatch(fromCheckoutActions.getCreditBundles());
  }
}
